module.exports = __webpack_public_path__ + "microCampaignAdd.svg?31e7c827db9be9ca7e056f3c191164e7";